import {Component} from '@angular/core';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-ui-switcher',
    templateUrl: './ui-switcher.component.html',
    styleUrls: ['./ui-switcher.component.scss'],
    standalone: false
})
export class UISwitcherComponent {

  private readonly HOST_MAPPING: Record<string, string> = {
    // Local development with ports
    'localhost': 'http://localhost-preview:4205',
    'localhost-preview': 'http://localhost:4205',
    '127.0.0.1': 'http://localhost-preview:4205',

    // Production environments with HTTPS
    'admin.popvalet.com': 'https://preview.popvalet.com',
    'admin-beta.popvalet.com': 'https://preview.popvalet.com',
    'preview.popvalet.com': 'https://admin.popvalet.com'
  };

  private readonly NEW_UI_HOSTS = new Set([
    'preview.popvalet.com',
    'localhost-preview'
  ]);

  constructor(private authService: AuthService) {}

  get isNewUI(): boolean {
    return this.NEW_UI_HOSTS.has(window.location.hostname);
  }

  public switchUI(): void {
    const token = this.authService.getAccessToken();
    if (!token) {
      console.warn('No authentication token found');
      return;
    }

    const targetBaseUrl = this.getTargetBaseUrl();
    if (!targetBaseUrl) {
      console.warn('Unable to determine target environment for:', window.location.hostname);
      return;
    }

    window.location.href = `${targetBaseUrl}${window.location.pathname}?token=${encodeURIComponent(token)}`;
  }

  private getTargetBaseUrl(): string | null {
    return this.HOST_MAPPING[window.location.hostname] || null;
  }

}
